// import logo from './logo.svg';
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./App.css";
import SignIn from "./pages/users/auth/signIn";
import CreateAccount from "./pages/users/auth/create-account";
import UserLayout from "./pages/users/layout";
import { ToastContainer } from "react-toastify";
import SendPasswordResetLink from "./pages/users/auth/sendPasswordResetLink";
import ResetPassword from "./pages/users/auth/resetPassword";
import AuthLayout from "./pages/users/auth/authLayout";
import AcceptInvitation from "./pages/users/auth/acceptInvitation";




function App() {
  return (
    <div className=" bg-[#EEF5FF] dark:bg-[#141D26]">
      <ToastContainer theme="colored" hideProgressBar={true} bodyClassName={() => 'toastBody flex items-center text-sm'} />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<AuthLayout />}>
            {/* <Route index element={<LandingPage />} /> */}
            <Route path="/" index element={<SignIn />} />
            <Route path="/create-account" element={<CreateAccount />} />
            <Route path="/password-reset-link" element={<SendPasswordResetLink />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/student-invitation" element={<AcceptInvitation />} />
          </Route>
          <Route path="*" element={<UserLayout />} />
        </Routes>
      </BrowserRouter>
    </div>
  );

}


export default App;
